import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../environments/environment";
import { ChatMessage } from "./ai-chat.model";

export interface AiChatHistoryEntry {
    messageId?: number;
    requestMessageId?: number;
    senderRole?: string;
    senderName?: string;
    textContent?: string;
    timestamp?: Date;
    success?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AiChatService {

    private http = inject(HttpClient);
    /** REST API base for AI Chat (formerly aiServiceApiUrl/chat). */
    private apiUrl = `${environment.restApiUrl}ai-chat`;

    /** Send a chat message and receive an AI response. */
    sendMessage(message: ChatMessage): Observable<ChatMessage> {
        return this.http.post<ChatMessage>(this.apiUrl, message);
    }

    /** Get chat history for the current user/session. */
    getHistory(sessionId?: string): Observable<AiChatHistoryEntry[]> {
        const params: any = {};
        return this.http.get<AiChatHistoryEntry[]>(`${this.apiUrl}/history`, { params });
    }

    /** Clear chat history for the current user/session. */
    clearHistory(sessionId?: string): Observable<{ success: boolean; message: string }> {
        const params: any = {};
        return this.http.delete<{ success: boolean; message: string }>(`${this.apiUrl}/history`, { params });
    }
}
